

import {Component, Vue} from "vue-property-decorator";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import TakipHazirlaFormWizard from "@/components/forms/form-wizard/eicrapro/TakipHazirlaFormWizard.vue";
import UyapBagliDegilView from "@/views/eicrapro/UyapBagliDegilView.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";

@Component({
  components: {UyapBagliDegilView, TakipHazirlaFormWizard}
})
export default class TakipHazirlaView extends Vue {
  // ESKİ KALDIRILDI
  taskTuru = TaskTuru;

  yeniEkranRoute(){
    this.$router.push(ProgramPaths.eicrapro + "/takip-hazirla-beta");
  }
}
